<template>
    <div class="text-vote">
        <div class="title">{{title}}</div>
        <!-- 2选项 -->
        <div v-if="isTwoOption" class="two-options">
            <!-- 未投票 && 未结束 -->
            <div class="two-un-voted" v-if="!isVoted&&!isFinish">
                <div class="option" v-for="item in options" :key="item.id" @click="goToVote(item)">{{item.name}}</div>
            </div>
            <!-- 已结束 || 已投票 -->
            <div class="two-finished" v-if="isFinish || isVoted">
                <div class="option-name">
                    <div class="left" @click="goToVote(options[0])">
                        <img 
                            v-if="userOptionId == options[0].id" 
                            class="selected-icon" 
                            :src="leftSelectIcon"
                        >
                        <div class="left-name" :style="{color: isFinish?'#999':'#4A70FF'}">
                            {{options[0].name}} {{options[0].percent}}%
                        </div>
                    </div>
                    <div class="right" @click="goToVote(options[1])">
                        <div class="right-name" :style="{color: isFinish?'#CCC':'#FF5E4D'}">
                            {{options[1]&&options[1].name}} {{options[1].percent}}%
                        </div>
                        <img 
                            v-if="userOptionId == options[1].id" 
                            class="selected-icon" 
                            :src="rightSelectIcon"
                        />
                    </div>
                </div>
                <div class="result-bar" :style="getBarStyle()">
                </div>
            </div>
        </div>
        <!-- 大于2个选项 -->
        <div v-else class="mul-options">
            <div v-for="item in options" :key="item.id" @click="goToVote(item)">
                <!-- 未投票 && 未结束 -->
                <div  v-if="!isVoted&&!isFinish" class="vote-1">{{item.name}}</div>
                <div 
                    v-else 
                    :class="[isFinish?'vote-3':userOptionId==item.id?'vote-2':'vote-3']" 
                    :style="{'--percent':item.percent+'%'}"
                >
                    <img 
                        :src="leftSelectIcon" 
                        v-if="userOptionId==item.id" 
                        class="selected-icon"/>
                    <div class="name">{{item.name}} </div>
                    <div class="percent">{{item.percent}}%</div>
                </div>
            </div>
        </div>
        <!-- 提示信息 -->
        <Tips :fields="fields" :isFinish="isFinish"/>
    </div>
</template>
<script>
import Tips from './tips.vue'
import leftSelectImg from '../../../../less/images/icon_chose_blue@2x.png'
import selectGreyImg from '../../../../less/images/icon_chose_grey@2x.png'

export default {
    props: ['fields'],
    components: {
        Tips
    },
    data() {
        return {
        }
    },
    computed: {
        leftSelectIcon() {
            return this.isFinish ? selectGreyImg : leftSelectImg
        },
        rightSelectIcon() {
            return this.isFinish ? selectGreyImg : '//statics.itc.cn/mptc-mpfe/img/article/icon_vote_chose_b.png'
        },
        title() {
            return this.fields?.title
        },
        options() {
            return this.fields?.options
        },
        // 2个选项
        isTwoOption() {
            return this.options?.length == 2
        },
        // 多于2个选项
        isMulOption() {
            return !this.isTwoOption
        },
        // 已投票
        isVoted() {
            return this.fields?.userOptionId || false
        },
        // 已选选项
        userOptionId() {
            return this.fields?.userOptionId || ''
        },
        // 已结束
        isFinish() {
            return this.fields?.endTime && new Date().getTime() > this.fields?.endTime || false
        },
    },
    mounted() {
    },
    methods: {
        getBarStyle(){
            let p1 = this.options[0].percent
            let p2 = this.options[1].percent
            if(this.isFinish) {
                if(!p1 && !p2 ) p1 = 50
                return `background:linear-gradient(to right,#999 0%,#999 ${p1}%,#ccc ${p1}%,#ccc 100%;`
            }
            else return `background:linear-gradient(to right,#4A70FF 0%,#4A70FF ${p1}%,#FF5E4D ${p1}%,#FF5E4D 100%;`
        },
        goToVote(item) {
            this.$emit('sendVote',item)
        }
    }
}
</script>
<style lang="less" scoped>
.text-vote {
    margin-bottom: 42px;/*px*/
    width: 100%;
    box-sizing: border-box;
    background: #F8F8F8;
    border-radius: 8px; /*px*/
    padding: 24px; /*px*/
    font-family: PingFangSC, PingFang SC;
    .title {
        font-weight: 600;
        font-size: 36px;/*px*/
        color: #111111;
        line-height: 52px;/*px*/
        text-align: left;
        font-style: normal;
    }
    .two-options {
        .two-un-voted {
            margin-top: 16px;/*px*/
            height: 64px;/*px*/
            width: 100%;
            background: url('../../../../less/images/discuss-btn-bg@2x.png') no-repeat center;
            background-size: 100% 100%;
            display: flex;
            .option {
                height: 100%;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 500;
                font-size: 28px;/*px*/
                color: #FFFFFF;
            }
        }
        .two-finished {
            .option-name {
                display: flex;
                height: 32px;/*px*/
                margin-top: 16px;/*px*/
                justify-content: space-between;
                align-items: center;
                .left{
                    width: 50%;
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                    .left-name{
                        height: 32px;/*px*/
                        font-size: 24px;/*px*/
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        line-height: 32px;/*px*/
                        margin-right: 8px;/*px*/
                        max-width: 320px;/*px*/
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .selected-icon {
                        width:28px;/*px*/
                        height: 28px;/*px*/
                        margin-bottom: 0 !important;
                        margin-right: 8px;/*px*/
                    }
                }
                
                .right{
                    width:50%;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    .right-name{
                        display: inline-block;
                        height: 32px;/*px*/
                        font-size: 24px;/*px*/
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        line-height: 32px;/*px*/
                        margin-left: 8px;/*px*/
                        max-width: 320px;/*px*/
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .selected-icon {
                        width:28px;/*px*/
                        height: 28px;/*px*/
                        margin-bottom: 0 !important;
                        margin-left: 8px;/*px*/
                    }
                }
            }
            .result-bar {
                margin-top: 8px;/*px*/
                width:100%;
                height: 24px;/*px*/
                border-radius: 40px;/*px*/
            }
        }
    }
    .mul-options {
        margin-top: 16px;/*px*/
        .vote-1 {
            margin-top: 8px;/*px*/
            height: 64px;/*px*/
            font-weight: 500;
            font-size: 28px;/*px*/
            color: #558DDC;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            border: 2px solid #EBEBEB;/*px*/
            border-radius: 32px;/*px*/
            background: white;
        }
        .vote-2 {
            margin-top: 8px;/*px*/
            height: 64px;/*px*/
            box-sizing: border-box;
            display: flex;
            align-items: center;
            font-weight: 500;
            font-size: 26px;/*px*/
            color: #1842DF;
            padding-left: 32px;/*px*/
            background:linear-gradient(to right,#DFE6FF var(--percent),#DFE6FF var(--percent),#fff var(--percent),#fff 100%);
            border-radius: 32px;/*px*/
            border: 2px solid #DFE6FF;/*px*/
            .name {
                white-space: nowrap; /* 禁止换行 */
                overflow: hidden; /* 隐藏溢出的内容 */
                text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
                text-align: center; /* 文字居中对齐 */
                max-width: 78%; /* 限制最大宽度 */
            }
            .percent {
                margin-left:8px;/*px*/
                font-weight: 400;
                font-size: 24px;/*px*/
                color: #1842DF;
            }
        }
        .vote-3 {
            margin-top: 8px;/*px*/
            height: 64px;/*px*/
            box-sizing: border-box;
            display: flex;
            align-items: center;
            font-weight: 400;
            font-size: 26px;/*px*/
            color: #111;
            padding-left: 32px;/*px*/
            background:linear-gradient(to right,#EBEBEB var(--percent),#EBEBEB var(--percent),#fff var(--percent),#fff 100%);
            border-radius: 32px;/*px*/
            border: 2px solid #ebebeb;/*px*/
            .name {
                white-space: nowrap; /* 禁止换行 */
                overflow: hidden; /* 隐藏溢出的内容 */
                text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
                text-align: center; /* 文字居中对齐 */
                max-width: 78%; /* 限制最大宽度 */
            }
            .percent {
                margin-left:8px;/*px*/
                font-weight: 400;
                font-size: 24px;/*px*/
                color: #666;
            }
        }
        .selected-icon {
            width: 24px;/*px*/
            height: 24px;/*px*/
            margin-right: 8px;/*px*/
            margin-bottom: 0 !important;
        }
    }
}
</style>